import { defineStore } from 'pinia';

type LayoutStoreState = {
  isOpenMainMenu: boolean;
};

export const useLayoutStore = defineStore('layoutStore', {
  state: (): LayoutStoreState => ({
    isOpenMainMenu: false,
  }),
  actions: {
    toggleOpenMainMenu(isOpen?: boolean) {
      if (typeof isOpen === 'boolean') {
        this.isOpenMainMenu = isOpen;
      } else {
        this.isOpenMainMenu = !this.isOpenMainMenu;
      }
    },
  },
});
